import { useCallback } from 'react';

/**
 * @deprecated This hook goes against the React rules of hooks. Use the `useCallback` hook instead
 * @example
 * ```js
 * const onFoo = useCallback(() => {
 *   dataRequest();
 * }, [dataRequest])
 * ```
 */
// TODO(https://perpay.atlassian.net/browse/KEY-3811):
// Expected the first argument to be an inline function expression
// eslint-disable-next-line react-hooks/exhaustive-deps, react-compiler/react-compiler
export const useConstCallback = (cb) => useCallback(cb, []);
